import { RadioProps } from '@material-ui/core';

export const radio: RadioProps = {
  color: 'primary',
  disableRipple: true,
  disableFocusRipple: true,
  disableTouchRipple: true,
};
